import { faqs } from '@/mocks/homeData';

export default function FAQSection() {
  return (
    <section id="faq" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h3 className="text-xs tracking-widest uppercase text-primary-500 font-medium mb-2">FAQ</h3>
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground-950">常见问题</h2>
          <p className="mt-3 text-sm text-foreground-600 max-w-xl mx-auto">关于90影视的常见疑问，这里都有答案</p>
        </div>

        <div className="max-w-3xl mx-auto space-y-4">
          {faqs.map((faq) => (
            <details key={faq.id} className="group bg-background-100 rounded-lg border border-secondary-200/60 overflow-hidden">
              <summary className="flex items-center justify-between px-6 py-4 cursor-pointer hover:bg-background-200/50 transition-colors list-none">
                <h3 className="text-sm md:text-base font-heading font-bold text-foreground-900 pr-4">{faq.question}</h3>
                <div className="w-6 h-6 flex items-center justify-center shrink-0 rounded-full bg-secondary-200 text-secondary-600 group-open:rotate-45 transition-transform duration-300">
                  <i className="ri-add-line text-sm"></i>
                </div>
              </summary>
              <div className="px-6 pb-5">
                <p className="text-sm text-foreground-700 leading-relaxed">{faq.answer}</p>
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}